import Vue from 'vue'
import Router from 'vue-router'
// 路由配置
import routeConfig from './config'

Vue.use(Router)

// 构造路由
const router = new Router(routeConfig)

export default router
